import moment from 'moment'
import relatorioChamadasHttpService from '../_services/RelatorioChamadasHttpService'

export const relatorioChamadasMethods = {
  async nextPage() {
    if (this.body.currentPage < this.body.lastPage) {
      this.showSkeleton = true

      this.body.currentPage++

      await Promise.all([
        this.listarRelatorioChamadas(this.body),
        this.$router.push({ query: { ...this.$route.query, page: this.body.currentPage } }),
      ])

      this.body.initialItem = this.getRelatorioChamadas.from
      this.body.finalItem = this.getRelatorioChamadas.to
      this.body.totalItens = this.getRelatorioChamadas.total

      this.chamadasRecebidas = this.getRelatorioChamadas.data.map(chamada => this.chamadaParaObjeto(chamada))

      this.showSkeleton = false
    }
  },
  async lastPage() {
    if (this.body.currentPage < this.body.lastPage) {
      this.showSkeleton = true

      this.body.currentPage = this.body.lastPage

      await Promise.all([
        this.listarRelatorioChamadas(this.body),
        this.$router.push({ query: { ...this.$route.query, page: this.body.currentPage } }),
      ])

      this.body.initialItem = this.getRelatorioChamadas.from
      this.body.finalItem = this.getRelatorioChamadas.to
      this.body.totalItens = this.getRelatorioChamadas.total

      this.chamadasRecebidas = this.getRelatorioChamadas.data.map(chamada => this.chamadaParaObjeto(chamada))


      this.showSkeleton = false
    }
  },
  async formerPage() {
    if (this.body.currentPage > 1) {
      this.showSkeleton = true

      this.body.currentPage--

      await Promise.all([
        this.listarRelatorioChamadas(this.body),
        this.$router.push({ query: { ...this.$route.query, page: this.body.currentPage } }),
      ])

      this.body.initialItem = this.getRelatorioChamadas.from
      this.body.finalItem = this.getRelatorioChamadas.to
      this.body.totalItens = this.getRelatorioChamadas.total

      this.chamadasRecebidas = this.getRelatorioChamadas.data.map(chamada => this.chamadaParaObjeto(chamada))

      this.showSkeleton = false
    }
  },
  async firstPage() {
    if (this.body.currentPage > 1) {
      this.showSkeleton = true

      this.body.currentPage = 1

      await Promise.all([
        this.listarRelatorioChamadas(this.body),
        this.$router.push({ query: { ...this.$route.query, page: this.body.currentPage } }),
      ])

      this.body.initialItem = this.getRelatorioChamadas.from
      this.body.finalItem = this.getRelatorioChamadas.to
      this.body.totalItens = this.getRelatorioChamadas.total

      this.chamadasRecebidas = this.getRelatorioChamadas.data.map(chamada => this.chamadaParaObjeto(chamada))

      this.showSkeleton = false
    }
  },

  async emitEvent() {
    const dataInicio = moment(this.datetimestart).format('YYYY-MM-DD HH:mm')
    const dataFim = moment(this.datetimeend).format('YYYY-MM-DD HH:mm')

    if (dataInicio > dataFim) {
      this.text = 'Data início não pode ser maior que a data fim.'
      this.snackbar = true
      return
    }

    this.chamadasRecebidas = []

    this.body.currentPage = 1

    if (this.$route.query.page) {
      await this.$router.push({ query: {} })
    } else {
      await this.$router.push({ query: { page: this.body.currentPage } })
    }

    this.body.dataHoraInicio = dataInicio
    this.body.dataHoraFim = dataFim

    this.showSkeleton = true
    await this.listarRelatorioChamadas(this.body)

    this.body.currentPage = this.getRelatorioChamadas.current_page
    this.body.lastPage = this.getRelatorioChamadas.last_page
    this.body.initialItem = this.getRelatorioChamadas.from
    this.body.finalItem = this.getRelatorioChamadas.to
    this.body.totalItens = this.getRelatorioChamadas.total

    this.chamadasRecebidas = this.getRelatorioChamadas.data.map(chamada => this.chamadaParaObjeto(chamada))

    this.showSkeleton = false
    this.lista = true
  },

  numeroOrigemDestinoFormer(numero) {
    const numeroIntermediario = numero.split(',')
    const numeroArray = []

    numeroIntermediario.forEach(numeros => {
      if (typeof numeros.split('-')[1] === 'undefined') {
        numeroArray.push(numeros)
      } else {
        const inicioRange = numeros.split('-')[0]
        const finalRange = numeros.split('-')[1]
        if (inicioRange > finalRange) {
          window.alert('Início do range não pode ser maior que final do range')
          return
        }

        for (let i = inicioRange; i <= finalRange; i++) {
          numeroArray.push(i.toString())
        }
      }
    })
    return numeroArray
  },

  protocolNovo(protocolo){
    const protocol = protocolo.split(',');
    return protocol
  },

  chamadaParaObjeto(chamada) {
    const dadosMain = {}
    let acao
    dadosMain.data = moment(chamada.dateStartCall).format('DD/MM/YYYY HH:mm:ss')
    dadosMain.finalChamada = moment(chamada.dateEndCall).format('DD/MM/YYYY HH:mm:ss')
    dadosMain.hangupSource = chamada.hangupSource
    dadosMain.numeroOrigem = chamada.numeroOrigem
    dadosMain.numeroDestino = chamada.numeroDestino
    
    if(chamada.protocol !== undefined){
      if(chamada.protocol[0] !== undefined){
        dadosMain.protocol = chamada.protocol[0]
      }
    }else{
      dadosMain.protocol = ''
    }
   

    dadosMain.atendente = chamada.atdCall
    dadosMain.status = chamada.status
    dadosMain.gravacoes = []
    dadosMain.transferencias = []
    dadosMain.centroDeCusto = `${chamada.centroDeCusto.codigo} - ${chamada.centroDeCusto.description}`
    dadosMain.idMongo = chamada._id
    acao = chamada.acao.split('\\')
    dadosMain.acao = acao[acao.length - 1]

    if (dadosMain.acao === 'DiscarConferencia') {
      dadosMain.uniqueidCall = chamada.uniqueidCall
      dadosMain.linkedid = chamada.linkedid
    }

    if (chamada.status === 'atendida') {
      const tempoTotalChamada = moment(chamada.dateEndCall, 'YYYY-MM-DD HH:mm:ss').diff(
        moment(chamada.dateStartCall, 'YYYY-MM-DD HH:mm:ss')
      )
      const d = moment.duration(tempoTotalChamada)
      const totalChamada = Math.floor(d.asHours()) + moment.utc(tempoTotalChamada).format('H:mm:ss')
      dadosMain.totalChamada = totalChamada

      const tempoConversacaoChamada = moment(chamada.dateEndCall, 'YYYY-MM-DD HH:mm:ss').diff(
        moment(chamada.dataAtdCall, 'YYYY-MM-DD HH:mm:ss')
      )
      const dd = moment.duration(tempoConversacaoChamada)
      const conversacaoChamada = Math.floor(dd.asHours()) + moment.utc(tempoConversacaoChamada).format('H:mm:ss')
      dadosMain.conversacaoChamada = conversacaoChamada

      dadosMain.gravacoes.push(chamada.record)
    } else {
      dadosMain.totalChamada = '00:00:00'
      dadosMain.conversacaoChamada = '00:00:00'
    }

    if (chamada.eventos) {
      dadosMain.eventos = chamada.eventos
    }

    this.showSkeleton = false
    return dadosMain
  },
  async exportExcel() {
    const params = {
      dataHoraInicio: moment(this.datetimestart).format('YYYY-MM-DD HH:mm'),
      dataHoraFim: moment(this.datetimeend).format('YYYY-MM-DD HH:mm'),
      numeroOrigem: this.body.numeroOrigem,
      numeroDestino: this.body.numeroDestino,
      centroDeCusto: this.body.centroDeCusto,
      status: this.body.status,
      protocol: this.body.protocol,
    }

    window.open(relatorioChamadasHttpService.exportPdf(params))
  },
}
